import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Network, Wallet, Tags, Landmark } from 'lucide-react';
import { ListSection, ListRow, PrimaryButton } from '../../components/RowList';
import SubmitBudgetButton from '../../components/SubmitBudgetButton';

// Module 8 — People (headcount & labour cost).
const People = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full overflow-y-auto font-sans bg-slate-100 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-6 py-10">

        <div className="mb-10 flex items-start justify-between gap-4">
          <div>
            <h1 className="m-0 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">People</h1>
            <p className="mt-2 text-base text-slate-500 dark:text-slate-400">
              Plan your establishment and the fully-loaded cost of employing it — headcount by structure, cost-to-company per grade.
            </p>
          </div>
          <SubmitBudgetButton module="MOD_8_PEOPLE" />
        </div>

        <ListSection title="Workforce Planning">
          <ListRow
            icon={Network}
            title="Structures"
            description="The nominal roll — one row per budgeted position, named where filled and flagged where vacant, each building up to a Final cost-to-company. Choose a site, or All sites to see everyone."
            actions={<PrimaryButton onClick={() => navigate('/people/structures')}>Open</PrimaryButton>}
          />
          <ListRow
            icon={Tags}
            title="Job Titles"
            description="A catalogue of job titles for the version, each mapped to a grade from Grades."
            actions={<PrimaryButton onClick={() => navigate('/people/job-titles')}>Open</PrimaryButton>}
          />
          <ListRow
            icon={Wallet}
            title="Grades"
            description="Salary-band reference per job title and grade — Low / Mid / Max monthly range and allowed annual leave. Structures reads its band from here."
            actions={<PrimaryButton onClick={() => navigate('/people/grades')}>Open</PrimaryButton>}
          />
          <ListRow
            icon={Landmark}
            title="GL Mapping"
            description="Map each Site + Job Title to a GL account and cost centre, so people costs roll up into a GL view of the budget."
            actions={<PrimaryButton onClick={() => navigate('/people/gl-mapping')}>Open</PrimaryButton>}
          />
        </ListSection>

      </div>
    </div>
  );
};

export default People;
